export function formatSnapshotDate(d: unknown): string {
  if (!d) return '';
  const date = d instanceof Date ? d : new Date(String(d));
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('es-ES');
}
